<template>
    <div class="documents">
        <b-card no-body>
            <b-card-header class="p-3">
                <b-row align-v="center" align-h="between">
                    <b-col cols="auto">
                        <h3 class="mb-0">Documents</h3>
                    </b-col>
                    <b-col cols="auto">
                        <el-button class="float-right py-0 text-primary" type="text">
                            View Details
                            <b-icon icon="chevron-right" />
                        </el-button>
                    </b-col>
                </b-row>
            </b-card-header>
            <div class="m-3">
                <p class="text-xs text-muted mb-2">Updated 22 Dec 2022</p>
                <div class="d-flex align-items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="20" viewBox="0 0 448 512"><path fill="#0BC196" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                    <p>KYC Form</p>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="20" viewBox="0 0 448 512"><path fill="#0BC196" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                    <p>Acknowledge Form</p>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import { Button } from 'element-ui'

export default {
    components: {
        [Button.name]: Button,
    },
    data() {
        return {

        }
    }
}
</script>